import { api } from "@/services/api"
import type { Params } from "@/services/api/odin/activities/flashcards/study-session/create"
import { useMutation } from "@tanstack/react-query"

export default function useCreateFlashcardStudySession() {
  const mutation = useMutation({
    mutationFn: (params: Params) => {
      return api.odin.activities.flashcards.studySession.create(params)
    },
  })

  return mutation
}
